'use client';

import { c as _c } from "react/compiler-runtime";
import { DonationIntervals } from 'api-graphql-types/enums';
import { toLowerCase } from 'betterplace-utils';
import { LayoutCluster, RadioButton, Tooltip } from 'design-system/client';
import { useTranslations } from 'next-intl';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
const intervals = [DonationIntervals.Single, DonationIntervals.Monthly, DonationIntervals.Yearly];
function IFrameIntervalSelection(t0) {
  const $ = _c(10);
  const {
    labelClass
  } = t0;
  const t = useTranslations();
  const {
    recurringPaymentMethods
  } = useDonationFormConfig();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["payment_method"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [paymentMethod] = useDonationFormValues(t1);
  let t2;
  if ($[1] !== paymentMethod || $[2] !== recurringPaymentMethods) {
    t2 = recurringPaymentMethods.includes(paymentMethod);
    $[1] = paymentMethod;
    $[2] = recurringPaymentMethods;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isRecurringPaymentMethod = t2;
  let t3;
  if ($[4] !== isRecurringPaymentMethod || $[5] !== labelClass || $[6] !== t) {
    t3 = intervals.map(interval => {
      const disabled = !isRecurringPaymentMethod && interval !== DonationIntervals.Single;
      return <Tooltip key={interval} content={t("nextjs.donate.recurring_disabled_tooltip")} inactive={!disabled}><DonationFormField name="interval" key={disabled ? undefined : interval} type="radio" as={RadioButton} className={labelClass} value={interval} disabled={disabled}>{t(`nextjs.donate.recurring_interval.${toLowerCase(interval)}`)}</DonationFormField></Tooltip>;
    });
    $[4] = isRecurringPaymentMethod;
    $[5] = labelClass;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <LayoutCluster space="300">{t3}</LayoutCluster>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export default IFrameIntervalSelection;